import api from '@/store/api';

/**
 * Gets a list of available systems
 * @param {*} param0
 */
const createPaymentIntent = (_, items) => {
  const url = '/Payment/create-payment-intent';
  const params = items;

  return api.post(url, params).then((response) => {
    return response.data;
  });
};
/**
 * Updates the payment intent amount
 * @param {*} _
 * @param {*} items
 * @returns
 */
const updatePaymentIntent = (_, items) => {
  const url = '/Payment/update-payment-intent';
  const params = items;

  return api.post(url, params).then((response) => {
    return response.data;
  });
};
/**
 * Gets a list of available systems
 * @param {*} param0
 */
const calculateTax = ({ state }, address) => {
  const url = '/Tax/calculate-tax';

  const params = {
    projectId: state.projectId,
    address: address
  };

  return api
    .post(url, params)
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      console.log(ex);
      //dispatch('app/showError', ex.toString(), { root: true });
      throw ex;
    });
};
/**
 * Saves the given address by making a POST request to the specified URL.
 *
 * @param {Object} _ - The placeholder parameter.
 * @param {Object} address - The address object to be saved.
 * @returns {Promise} A promise that resolves to the response data.
 */
const saveAddress = ({ state }, address) => {
  const url = '/Address/save';
  const params = {
    address: address,
    projectId: state.projectId
  };

  return api.post(url, params).then((response) => {
    return response.data;
  });
};
/**
 * Converts the order by making a POST request to the '/Project/ConvertToOrder' endpoint.
 * @returns {Promise} A promise that resolves to the converted order data.
 */
const convertOrder = ({ state }) => {
  const url = '/Project/ConvertToOrder';
  const params = {
    id: state.projectId
  };

  return api.post(url, params).then((response) => {
    return response.data;
  });
};

export default {
  createPaymentIntent,
  updatePaymentIntent,
  calculateTax,
  saveAddress,
  convertOrder
};
